import EventManager from '../__internals__/EventManager'
import trackEvent from './trackEvent'
import createEventType from '../__internals__/createEventType'
import { sanitizeUrl } from '../__internals__/utils'

const trackView =
  (eventManager: EventManager) => (pathname: string, eventName?: string) => {
    trackEvent(eventManager)({
      ...createEventType('pageload', eventName),
      view: {
        name: pathname,
      },
      browser: {
        url: sanitizeUrl(window.location.href),
      },
    })
  }

export default trackView
